import React from 'react';
import { CalendarBlankIcon } from '@phosphor-icons/react';

interface DateInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  icon?: React.ElementType;
  onIconClick?: () => void;
  wrapperClassName?: string;
  inputClassName?: string;
  size?: 'sm' | 'md';
}

const sizeClasses = {
  sm: 'h-[28px] p-2 text-xs border-2',
  md: 'h-[36px] px-[13px] py-[8px] text-[14px] border-2'
};

const DateInput = React.forwardRef<HTMLInputElement, DateInputProps>(
  (
    { icon: Icon = CalendarBlankIcon, onIconClick, className, wrapperClassName, inputClassName, size = 'md', ...props },
    ref
  ) => {
    return (
      <div
        className={`flex items-center bg-white w-full gap-2 rounded-[6px] font-medium font-raleway leading-[100%] border-border-default focus-within:border-border-active text-content-subtle focus-within:text-content-default ${sizeClasses[size]} ${wrapperClassName || ''} ${props.disabled ? 'opacity-60 cursor-not-allowed bg-bluegray-50' : ''}`}
      >
        <input
          ref={ref}
          type="date"
          className={`w-full outline-none bg-transparent ${inputClassName || ''} ${className || ''}`}
          style={{ WebkitAppearance: 'none', appearance: 'none' }}
          {...props}
        />
      </div>
    );
  }
);
DateInput.displayName = 'DateInput';

export { DateInput };
export default DateInput;
